import React from 'react';
import { useSignup } from './SignupProvider';
import RestaurantInfoStep from './RestaurantInfoStep';
import ManagerInfoStep from './ManagerInfoStep';
import TableCountStep from './TableCountStep';
import PaymentStep from './PaymentStep';
import SuccessStep from './SuccessStep';

const SignupStepRouter: React.FC = () => {
  const { state } = useSignup();
  const { currentStep } = state;

  const renderStep = () => {
    switch (currentStep) {
      case 'restaurant':
        return <RestaurantInfoStep />;
      case 'manager':
        // Skip manager step if in additional restaurant mode
        if (state.isAdditionalRestaurant) {
          return <TableCountStep />;
        }
        return <ManagerInfoStep />;
      case 'tables':
        return <TableCountStep />;
      case 'pricing':
        // For now, pricing is integrated into tables step
        return <TableCountStep />;
      case 'payment':
        return <PaymentStep />;
      case 'processing':
        return (
          <div className="processing-step">
            <div className="processing-content">
              <div className="spinner-large"></div>
              <h2>Processing Your Account...</h2>
              <p>Please wait while we set up your restaurant account</p>
              <div className="processing-steps">
                <div className="processing-item">✓ Payment confirmed</div>
                <div className="processing-item">⏳ Creating restaurant account</div>
                <div className="processing-item">⏳ Setting up manager access</div>
                <div className="processing-item">⏳ Configuring system</div>
              </div>
            </div>
          </div>
        );
      case 'success':
        return <SuccessStep />;
      default:
        return <RestaurantInfoStep />;
    }
  };

  return (
    <div className="signup-step-router">
      {renderStep()}
      
      <style>{`
        .signup-step-router {
          width: 100%;
        }

        .processing-step {
          max-width: 600px;
          margin: 0 auto;
          padding: 40px 20px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
        }

        .processing-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 24px;
        }

        .spinner-large {
          width: 60px;
          height: 60px;
          border: 4px solid #e9ecef;
          border-top: 4px solid #2196F3;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .processing-step h2 {
          color: #2196F3;
          margin: 0;
          font-size: 2rem;
          font-weight: 600;
        }

        .processing-step p {
          color: #6c757d;
          font-size: 1.1rem;
          margin: 0;
        }

        .processing-steps {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-top: 20px;
        }

        .processing-item {
          color: #495057;
          font-size: 1rem;
          padding: 8px 0;
        }
      `}</style>
    </div>
  );
};

export default SignupStepRouter;
